export default __webpack_public_path__ + "static/media/parkingslot1.d49d8783.png";